module.exports = __webpack_public_path__ + "media/icons/drzwi@3x-650df088.svg";